import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'coin-message-toolbar',
  templateUrl: './message-toolbar.component.html',
  styleUrl: './message-toolbar.component.scss',
  imports: [MatTooltip, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageToolbarComponent {
  actions = input<MessageToolbarAction[]>([]);
}

export type MessageToolbarAction = {
  icon: string;
  tooltip: string;
  action: () => void;
};
